import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import {
    expr,
    registerHelperFunction,
    registerSetupCode,
    resolveBoard,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import {
    GPS_BASE_HELPER_CODE,
    GPS_BASE_HELPER_CODE_BLUE,
    GPS_POSITION_LABELS,
    gpsGlobalCode,
    gpsGlobalCodeBlue,
    gpsGlobalCodes,
    markGpsUsed,
} from '@/(routers)/boards/editor/block/generators/arduino/blocks/gps/helper/gps_helper';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

const SPEED_HELPER_CODE = `float _sbeGpsSpeed(TinyGPSPlus* gps, SoftwareSerial* serial, bool kmph, bool* warned, const char* label) {
  _sbeGpsCheckAge(gps, serial, warned, label);
  if (!gps->speed.isValid()) return 0.0;
  return kmph ? gps->speed.kmph() : gps->speed.mps();
}`;

const SPEED_HELPER_CODE_BLUE = `float _sbeGpsSpeed_blue(TinyGPSPlus* gps, bool kmph, bool* warned, const char* label) {
  _sbeGpsCheckAge_blue(gps, warned, label);
  if (!gps->speed.isValid()) return 0.0;
  return kmph ? gps->speed.kmph() : gps->speed.mps();
}`;

export function register(gen: any): void {
    gen.forBlock['gps_speed'] = function (block: Blockly.Block): [string, number] {
        const position = block.getFieldValue('POSITION') as Position;
        const unit = block.getFieldValue('UNIT') as string;
        const board = resolveBoard(block);
        const pins = BOARD_CONFIG[board].pins[position];
        const rx = pins.second;
        const tx = pins.first;
        const label = GPS_POSITION_LABELS[position] ?? position;

        markGpsUsed();

        if (board === 'blue') {
            gpsGlobalCodes.set(`${tx}`, gpsGlobalCodeBlue(tx));
            registerHelperFunction('gps_base', GPS_BASE_HELPER_CODE_BLUE);
            registerHelperFunction('gps_speed_fn', SPEED_HELPER_CODE_BLUE);
            registerSetupCode(
                `gps_${tx}`,
                `  Serial2.begin(9600, SERIAL_8N1, ${rx}, ${tx});\n  _sbeGpsBegin_blue("${label}");\n`,
            );
            const code =
                unit === 'MPS'
                    ? `_sbeGpsSpeed_blue(&_sbeGps_${tx}, false, &_sbeGpsWarned_${tx}, "${label}")`
                    : `_sbeGpsSpeed_blue(&_sbeGps_${tx}, true, &_sbeGpsWarned_${tx}, "${label}")`;
            return expr(code);
        }

        gpsGlobalCodes.set(`${tx}`, gpsGlobalCode(rx, tx));
        registerHelperFunction('gps_base', GPS_BASE_HELPER_CODE);
        registerHelperFunction('gps_speed_fn', SPEED_HELPER_CODE);
        registerSetupCode(`gps_${tx}`, `  _sbeGpsBegin(&_sbeGpsSerial_${tx}, "${label}");\n`);
        const code =
            unit === 'MPS'
                ? `_sbeGpsSpeed(&_sbeGps_${tx}, &_sbeGpsSerial_${tx}, false, &_sbeGpsWarned_${tx}, "${label}")`
                : `_sbeGpsSpeed(&_sbeGps_${tx}, &_sbeGpsSerial_${tx}, true, &_sbeGpsWarned_${tx}, "${label}")`;
        return expr(code);
    };
}
